export default "__VITE_ASSET__DPPyKvAu__"